import { Field, Switch, Label } from "@headlessui/react";
import React, { Fragment } from "react";

type ToggleTextProps = {
  texto: string;
  textoSecondary?: string;
  checked: boolean;
  onChange: any;
  disabled?: boolean;
};

export const ToggleText: React.FC<ToggleTextProps> = ({
  texto,
  textoSecondary,
  checked,
  onChange,
  disabled,
}) => (
  <Fragment>
    <Field className="flex items-center">
      <Switch
        disabled={disabled}
        checked={checked}
        onChange={onChange}
        className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 data-[checked]:bg-primary-500"
      >
        <span
          aria-hidden="true"
          className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
        />
      </Switch>
      <Label as="span" className="ml-3 text-sm">
        <span className="font-medium text-gray-900">{texto}</span>{" "}
        <span className="text-gray-500">{textoSecondary}</span>
      </Label>
    </Field>
  </Fragment>
);
